export enum RequestPriority {
	Immediate = 1,
	VeryUrgent = 2,
	Urgent = 3,
	VeryImportant = 4,
	Important = 5,
}
